import React from 'react';
import PropTypes from 'prop-types';
import { DEVICE } from '@/constants';
import './style.less';

const K = ({ os }) => (
  <React.Fragment>
    <div className="sun" />
    <div className="cloud1" />
    <div className="cloud2" />
    <div className="cloud3" />
    {os !== DEVICE.PC && <div className="cloud4" />}
    <div className="cloud5" />
    <div className="sky-wheel" />
    <div className="plane" />
    {os === DEVICE.PC && <div className="plane2" />}
    <div className="balloon" />
    <div className="car" />
    <div className="building" />
  </React.Fragment>
);

K.propTypes = {
  os: PropTypes.string,
};
export default K;
